import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=5e918c66&scoped=true"
import script from "./CreateCategory.vue?vue&type=script&lang=ts"
export * from "./CreateCategory.vue?vue&type=script&lang=ts"
import style0 from "./CreateCategory.vue?vue&type=style&index=0&id=5e918c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e918c66",
  null
  
)

export default component.exports